import { Text, TextInput } from 'react-native';

/**
 * Desactiva el escalado de texto globalmente en iOS y Android
 * Aplica múltiples estrategias para garantizar que allowFontScaling=false
 */
export function disableFontScaling() {
  // Estrategia 1: defaultProps (React Native clásico)
  if (Text.defaultProps == null) {
    Text.defaultProps = {};
  }
  if (TextInput.defaultProps == null) {
    TextInput.defaultProps = {};
  }
  
  Text.defaultProps.allowFontScaling = false;
  Text.defaultProps.maxFontSizeMultiplier = 1;
  TextInput.defaultProps.allowFontScaling = false;
  TextInput.defaultProps.maxFontSizeMultiplier = 1;

  // Estrategia 2: Parchear el render de Text (React Native Fabric/nuevo)
  // Esto intercepta el render a nivel nativo
  const TextRender = Text.render;
  const TextInputRender = TextInput.render;

  if (TextRender) {
    Text.render = function (props, ref) {
      return TextRender.call(this, {
        ...props,
        allowFontScaling: false,
        maxFontSizeMultiplier: 1,
      }, ref);
    };
  }

  if (TextInputRender) {
    TextInput.render = function (props, ref) {
      return TextInputRender.call(this, {
        ...props,
        allowFontScaling: false,
        maxFontSizeMultiplier: 1,
      }, ref);
    };
  }

  // Estrategia 3: Parchear setNativeProps (para actualizaciones dinámicas)
  const originalTextSetNativeProps = Text.prototype?.setNativeProps;
  const originalTextInputSetNativeProps = TextInput.prototype?.setNativeProps;

  if (originalTextSetNativeProps) {
    Text.prototype.setNativeProps = function (nativeProps) {
      if (nativeProps) {
        nativeProps.allowFontScaling = false;
        nativeProps.maxFontSizeMultiplier = 1;
      }
      return originalTextSetNativeProps.call(this, nativeProps);
    };
  }

  if (originalTextInputSetNativeProps) {
    TextInput.prototype.setNativeProps = function (nativeProps) {
      if (nativeProps) {
        nativeProps.allowFontScaling = false;
        nativeProps.maxFontSizeMultiplier = 1;
      }
      return originalTextInputSetNativeProps.call(this, nativeProps);
    };
  }

  // console.log('✅ [FontScaling] Desactivado globalmente en Text y TextInput');
  // console.log('🔒 [FontScaling] Aplicadas 3 estrategias de bloqueo');
}
